/* tslint:disable */
var TResponsiveMultiOptions = Object.assign({}, TBaseMultiOptions,
    {
        buildCombo(mode, selections) {
            this.isRenderedIcon = false;

            return `
                <div id="combo_options" class="bets-options combo expanded" data-uat="combo-options">
                    ${this.buildComboOptionsTitle(mode)}
                    <div class="bets-options-wrap">
                        ${this.buildComboInner(mode, selections)}
                        ${this.buildQuickStakeButtons(mode)}
                    </div>    
                    <input id="comboOptions" type="radio" name="betOptions" value="combo" onchange="UniSlipBlock.selectSlipMode(this.value)" style="display: none;" checked="checked" />
                    ${this.buildComboBonusMessage(this.isRenderedIcon)}
                </div>
            `;
        },

        buildUKMultiplesOptions: function (mode, selections) {
            BetSlipUtil.getAllBetsDepositValue(mode);

            var deposit = BetSlip.getStakeBoxValue(mode.AllBetsDeposit);
            var showMultiplesClass = mode.ShowMultiples ? "" : "collapsed";
            var toReturnValue = mode.AllBetsDeposit > 0 ? mode.getSinglesAllReturn() : '';

            var returnBoxContext = {
                toReturnValue: toReturnValue,
                id: 'singlesAll_return_value'
            };

            this.isRenderedIcon = false;
            return `
                <div class="bets-options uk_multiples" id = "jsBetslipMultiples" >
                    <div class="ukSlipHeading ukSlipHeading--toggleable ${showMultiplesClass}" id = "jsUkToggleableHeader" onclick = "UniSlipBlock.toggleMultiples('collapsed')" >
                        <span class="icon i-12 i-o-controls-arrow-right" rel = "arr_icon"></span>
                        <span class="bets-options-title">${$dict.bs("Multiples")}</span>
                    </div>

                    <div class="ukSlipOptions" data-uat="uk-slip-options">
                        <div class="betSlip-bets-item ${this.getUKBetsItemCssClass()}">
                            <div class="betSlip-row-wrapper" data-uat="bet-slip-row-wrapper">
                                <div class="betSlip-row-content">
                                    <div class="betSlip-title-count">
                                        <strong data-uat="bet-name"> ${$dict.bs("Singles")}</strong>
                                        <span data-uat="bet-separator">X</span>
                                        <span class="betSlip-bets-count" data-uat="bet-count">
                                            ${BetSlip.getSelectionsCount()} ${$dict.bs("Bets")}
                                        </span>
                                    </div>
                                </div>

                                <div class="betSlip-row-stake">
                                    <div class="stake-options">
                                        <div class="betSlip-stake" data-uat="bet-slip-stake">
                                            ${this.buildToReturnValue(returnBoxContext)}
                                            ${TSlipShared.createStakeBox(this.getAllStakeBoxInner(deposit), deposit)}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        ${this.buildComboInner(mode, selections)}
                        ${this.buildUKSystemInner(mode, selections)}
                    </div>

                    ${this.buildComboBonusMessage(this.isRenderedIcon)}
                </div>
            `;
        },

        buildSystem: function (mode, selections) {
            return `
                <div id="system-options" class="bets-options system" data-uat="system-options">
                    <div class="heading openable">
                        <label for= "systemOptions" data-uat="system-options-label">
                            ${$dict.bs("SystemOptionsTitle")}
                        </label>
                    </div>

                    <input id = "systemOptions" type="radio" name="betOptions" value="system" onchange="UniSlipBlock.selectSlipMode(this.value)" style = "display: none;" />

                    <div class="bets-options-wrap" >
                        ${this.buildSystemInner(mode, selections)}
                    </div>

                    <div id = "comboAdditionalMsgWrapper">
                        ${this.buildComboBonusMessageInSystem(mode)}
                    </div>
                </div>
            `;
        },

        buildSystemInnerLayout: function (mode, options) {
            return `
                <div class="betSlip-bets-item">
                    <div class="betSlip-row-wrapper" data-uat="bet-slip-row-wrapper">
                        <div class="betSlip-row-content">
                            ${this.buildSystemOptionGroups(mode, options)}
                        </div>
                        <div class="betSlip-row-stake system">
                            <div class="betSlip-checkbox">
                                <!--Divide EW, if possible! -->
                                ${this.buildSystemStakeAndEWBoxes(mode, options)}
                                <!-- -->
                            </div>
                        </div>
                    </div>
               </div>
            `;
        },

        buildSystemOptionGroups: function (mode, options) {
            var __html = "";
            __html += `
            <div class="bets-options-group" id="betsOptionsDiv" data-uat="bets-options-div">`;
            //Individual variants
            if (options.linesCount <= mode.MaxSelections) {
                __html += this.buildSystemIndividualVariants(mode, options);
            } __html += `
                ${this.buildSystemNamedVariants(mode, options)}
            </div>
            `;
            return __html;
        },

        createComboVariantLine: function (mode, options, selections, betType, isFirst) {
            var isFullVariant = options.hasOwnProperty('odds');
            var hasComboBonusClass = (ComboBonusProvider.ComboBonuses != null && !Modes.isCombinatorMode(mode)) ? 'hasComboBonus' : '';
            var freeBet = Modes.getAvailableMultiFreeBets(mode, selections, options.key);
            var hasFreeBetClass = freeBet ? 'has_free_bet' : '';
            var toReturnValue = mode.getComboVariantReturn(options.key) || '';
            var returnBoxContext = {
                toReturnValue: toReturnValue,
                id: 'combo_return_value_' + options.key
            };
            var isAsianView = typeof (currentBettingViewID) !== 'undefined' && currentBettingViewID === 2;
            var __html = "";
            __html += `
                <div class="betSlip-bets-item combo-bet" data-uat="combo-bet">
                    <div id="betSlip_row_wrapper_<%=options.key%>" class="betSlip-row-wrapper" data-uat="bet-slip-row-wrapper">
                        <div class="betSlip-row-content ${hasComboBonusClass} ${hasFreeBetClass}">`;
            if (!isAsianView) {
                __html += TSlipShared.createComboMaxBet(mode, isFirst);
            }

            __html += `
                <div class="betSlip-title-count">
                    <strong data-uat="bet-name"> ${Modes.isCombinatorMode(mode) ? mode.ComboNames[options.key] : $dict.bs("ComboNames_" + options.key)} </strong>
                        <span data-uat="bet-separator"> X </span>
                        <span class="betSlip-bets-count"
            `;
            if (!isFullVariant) {
                __html += ` data-uat="bet-count"`;
            }
            __html += `>`;
            
            if (isFullVariant) { 
                __html += `
                    <span class="betSlip-bets-count-sep" data-uat="bet-count"> 1 </span>
                    <span class="betSlip-bets-count-sep">@</span>
                    <span id = "comboSingleOdds" data-uat="bet-odds" data-uat="bet-odds">${options.odds}</span>
                `;
            }
            else {
                __html += `
                    ${options.betsCount} ${options.comboName}
                `;
            }
            
            __html += `
                    </span>
                    ${this.buildComboBonusIcon(betType, freeBet, mode)}
                </div>
            `;
            
            if (!isAsianView) {
                __html += `
                            ${TMinMax.createMinForComboSlipMode(mode, selections)}
                `;
            }
            
            __html += `
                </div>
                <div class="betSlip-row-stake combo">
                    <div class="betSlip-checkbox">
            `;
            
            if (options.hasEachway) {
                __html += `
                    ${this.createEachwayBox.defaultBox(mode, options)}
                `;
            }
            
            __html += `
                </div>
                <div class="stake-options">
                    <div class="betSlip-stake">
                        ${TSlipShared.createStakeBox(this.getComboVariantStakeBoxInner(options), options.deposit)}
            `;

            if (isAsianView) {
                __html += `
                    <div class="combo-min-max-buttons">
                        ${TMinMax.createMinForComboSlipMode(mode, selections)}
                        ${TSlipShared.createComboMaxBet(mode, isFirst)}
                    </div>
                `;
            }

            __html += `
                                ${this.buildToReturnValue(returnBoxContext)}
                            </div>
                        </div>
                        ${this.createMultiFreeBetSelect(mode, selections, options.key)}
                        </div>
                    </div>
                </div>
            `;
            return __html;
        },

        getUKBetsItemCssClass: function (options?: {}): string {
            return ''
        },
        
        createUKComboVariantLine: function (mode, options, selections, betType) {
            var isFullVariant = options.hasOwnProperty('odds');
            var toReturnValue = mode.getComboVariantReturn(options.key) || '';
            var freeBet = Modes.getAvailableFreeBetsForUKSlip(mode, UKSlipModeSubModes.Combo, null, selections, options.key);
            //var isSelectedFreeBet = (freeBet && freeBet.SelectedID != 0);
            var toReturnValue = mode.getComboVariantReturn(options.key) || '';
            var returnBoxContext = {
                toReturnValue: toReturnValue,
                id: 'combo_return_value_' + options.key
            };
            var hasComboBonusClass = (ComboBonusProvider.ComboBonuses != null && !Modes.isCombinatorMode(mode)) ? 'hasComboBonus' : '';
            var __html = "";
                __html += `
                    <div class="betSlip-bets-item combo-bet ${this.getUKBetsItemCssClass(options)}" data-uat="combo-bet">
                        <div id="betSlip_row_wrapper_${options.key}" class="betSlip-row-wrapper${IsUKBetSlip ? ' ukSlipOptions__line' : ''}" data-uat="bet-slip-row-wrapper">
                            <div class="betSlip-row-content ${hasComboBonusClass}">
                                <div class="betSlip-title-count">
                                    <strong data-uat="bet-name"> ${$dict.bs("ComboNames_" + options.key)} </strong>
                                    <span data-uat="bet-separator"> X </span>
                                    <span class="betSlip-bets-count"
                `; 
                if (!isFullVariant) {
                    __html += ` data-uat="bet-count"`;
                }
                __html += `>`;
                
                if (isFullVariant) { 
                    __html += `
                        <span class="betSlip-bets-count-sep" data-uat="bet-count"> 1 </span>
                        <span class="betSlip-bets-count-sep">@</span> 
                        <span id = "comboSingleOdds" class="emphasis" data-uat="bet-odds">${options.odds}</span>
                    `;
                 } 
                else 
                { 
                     __html += `
                        ${options.betsCount} ${options.comboName}
                        `;
                } 
                
                __html += `
                    </span>
                    ${this.buildComboBonusIcon(betType, freeBet, mode)}
                    </div>
                    </div>
                    <div class="betSlip-row-stake">
                        <div class="betSlip-checkbox">
                `;
                
                if (options.hasEachway) {
                    __html += `
                    ${this.createEachwayBox.UKBox(mode, options)}
                    `;
                }
                
                __html += `
                </div>
                <div class="stake-options">
                    <div class="betSlip-stake">
                        ${this.buildToReturnValue(returnBoxContext)}
                        ${TSlipShared.createStakeBox(this.getComboVariantStakeBoxInner(options), options.deposit)}
                    </div>
                    ${TSlipShared.createUKComboMaxBet(options, mode, selections)}
                    ${this.createUKMultiFreeBetSelect(mode, selections, options.key)}
                </div>
                </div>
                </div>
                </div>
            `;

            return __html;
        },

        buildToReturnValue: function (context) {
            if (BetSlipUtil.showNAForRelatedSelections()) {
                return '';
            }

            return `
                <div class="betSlip-stake-return returnBox" >
                    <span class="betSlip-stake-return-head" data-uat="combo-bet-total-return-label"> ${$string("BettingHistory").Return} </span>
                    <span class="betSlip-stake-return-value" id="${context.id}" data-uat="bet-slip-total-return-value"> ${context.toReturnValue} </span>
                </div>
            `;
        },

        createSystemVariantLine: function (mode, options) {
            return `
                <label class="radio-label" data-uat="system-bet" >
                    <input class="bets-option" name="systemType" data-uat="system-bet-radio" value="${options.key}" type="radio" onclick="rebuildSystemStake()" ${mode.SystemKey == options.key ? "checked='1'" : ""} ${mode.IsBetInProcess && mode.SystemKey != options.key ? " disabled" : "" } />
                        <span class="icon i-24 i-o-controls-radio-mark"> </span>
                        <div id="comboBonusIconWrapper_${options.key}" class="betSlip-combo-bonus" data-uat="combo-bonus">
                            ${this.buildComboBonusIconInSystem(mode, options)}
                        </div>
                        <span class="bets-options-name" data-uat="bet-name">
                            ${options.systemName} (${options.betsCount} ${$dict.bs("ComboNamesBets")})
                        </span>
                </label>
            `;
        },

        createUKSystemVariantLine: function (mode, options, selections) {
            var toReturnValue = mode.getSystemVariantReturn(options.key) || '';
            var returnBoxContext = {
                toReturnValue: toReturnValue,
                id: 'system_return_value_' + options.key
            };

            var __html = "";
    
            __html += `
                <div class="betSlip-bets-item system-bet ${this.getUKBetsItemCssClass(options)}" data-uat="combo-bet">
                    <div class="betSlip-row-wrapper" data-uat="bet-slip-row-wrapper">
                        <div class="betSlip-row-content">
                            <div class="betSlip-title-count">
                                <strong data-uat="bet-name">${options.systemName}</strong>
                                <span data-uat="bet-separator"> X </span>
                                <span class="betSlip-bets-count" data-uat="bet-count">
                                    ${options.betsCount} ${options.betsString}
                                </span>
                            </div>

                            <div class="betSlip-row-stake">
                                <div class="betSlip-checkbox">
            `;
    
            if (options.hasEachway) {
                __html += this.createEachwayBox.UKBox(mode, options)
            }

            __html += `
                </div>
                <div class="stake-options">
                    <div class="betSlip-stake">
                        ${this.buildToReturnValue(returnBoxContext)}
                        ${TSlipShared.createStakeBox(this.getSystemVariantStakeBoxInner(options), options.deposit)}
                    </div>
                </div>
                ${TSlipShared.createUKSystemMaxBet(options, mode, selections) }
                </div>

                </div>
                </div>
                </div>
            `;

            return __html;
        },

        buildTeaser: function (mode, selections) {
            return `
                <div id="teaser_options" class="teaser-options teaser">
                    <div class="heading openable">
                        <label for= "teaserOptions">
                            ${$dict.bs("TeaserOptionsTitle")}
                        </label>
                    </div>

                    <input id="teaserOptions" class="isHidden" type="radio" name="betOptions" value="teaser" onchange="UniSlipBlock.selectSlipMode(this.value)" />
                    <div class="betSlip-bets-item teaser-bet">
                        ${this.buildTeaserInner(mode, selections)}
                    </div>
                </div>
            `;
        }
        
    });
    
    window.TResponsiveMultiOptions = TResponsiveMultiOptions;